import React, { useRef } from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useDispatch } from "react-redux";
import {
  changeQty,
  posInputFocus,
  removeItem,
  updateDiscount,
  updateQty,
} from "../../../store/pos/posSlice";
import { getMediaUrl } from "../../../utils/mediaUrl";

function ProductLisTr({ item }: any) {
  const dispatch = useDispatch();
  const inputRef = useRef<HTMLInputElement>(null);

  const taxLabel = item?.taxPercentage
    ? `${item.taxPercentage}%`
    : item?.tax
      ? `${item.tax}%`
      : "—";

  return (
    <tr className="cart-row">
      {/* Image */}
      <td className="cart-img-cell">
        <div className="cart-img-wrap">
          {item?.image ? (
            <img
              src={getMediaUrl(item.image)}
              alt={item.name}
            />
          ) : (
            <div className="cart-img-placeholder">
              {item?.name?.[0]?.toUpperCase() ?? "?"}
            </div>
          )}
        </div>
      </td>

      {/* Name */}
      <td className="cart-name-cell">
        <div className="cart-item-name">
          {item?.name}
          {item?.scale && item.scale !== "Unit" ? ` (${item.scale})` : ""}
        </div>
        <div className="cart-item-code">{item?.itemNumber}</div>
      </td>

      {/* QTY */}
      <td className="cart-qty-cell">
        <div className="cart-qty">
          <button
            className="cart-qty-btn"
            onClick={() =>
              dispatch(updateQty({ actions: "decrease", id: item?.id }))
            }
          >
            <RemoveIcon style={{ fontSize: 13 }} />
          </button>
          <input
            type="number"
            className="cart-qty-input"
            value={item?.quantity}
            onChange={(e) =>
              dispatch(
                changeQty({
                  value: e.target.value,
                  id: item?.id,
                  scale: item?.scale,
                }),
              )
            }
            ref={inputRef}
            onFocus={(e) => {
              e.target.select();
              dispatch(posInputFocus({ name: "qty", value: item?.id }));
            }}
          />
          <button
            className="cart-qty-btn"
            onClick={() =>
              dispatch(updateQty({ actions: "increase", id: item?.id }))
            }
          >
            <AddIcon style={{ fontSize: 13 }} />
          </button>
        </div>
      </td>

      {/* Tax */}
      <td className="cart-tax-cell">
        <span className="cart-tax-badge">{taxLabel}</span>
      </td>

      {/* Unit price */}
      <td className="cart-price-cell">{item.price.toFixed(2)}</td>

      {/* Disc */}
      <td className="cart-disc-cell">
        <input
          type="text"
          className="cart-discount-input"
          onChange={(e) =>
            dispatch(updateDiscount({ value: e.target.value, id: item?.id }))
          }
          onFocus={() =>
            dispatch(posInputFocus({ name: "items", value: item?.id }))
          }
          value={item.discount}
        />
      </td>

      {/* Sub total */}
      <td className="cart-subtotal-cell">{item.finalPrice.toFixed(2)}</td>

      {/* Delete */}
      <td className="cart-del-cell">
        <button
          className="cart-del-btn"
          onClick={() => dispatch(removeItem(item?.id))}
        >
          <DeleteOutlineIcon style={{ fontSize: 16 }} />
        </button>
      </td>
    </tr>
  );
}

export default ProductLisTr;
